import styled from "styled-components";
import Colors from "../../../../Constant/Colors";
import { FONTS, STYLES } from "../../../../Constant/Theme";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;
export const MainDiv = styled.div`
  height: 80%;
  width: 100%;
  margin: 10px;
  align-items: center;
  overflow-y: scroll;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
export const Title = styled.div`
  ${STYLES.VerticalLeftAlign};
  margin-left: 20px;
  width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
export const EachHeading = styled.div`
  /* width: 80px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 5px;
  background-color: ${Colors.primary};
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid
    ${(props) => (props.selected ? Colors.primary : props.color)};
  background-color: ${(props) =>
    props.selected ? Colors.whiteThemeColor : props.color};
`;
export const PopupDiv = styled.div`
  ${STYLES.VerticalAlign};
  /* padding:40px ; */
  margin: 30px 0px;
  max-height: 90vh;
  max-width: 50vw;
  border-radius: 7px;
  cursor: pointer;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
